import { Component, OnInit, Input } from "@angular/core";
import { News } from "./model/news.model";
import { DownloadService } from "../services/download.service";

@Component({
  selector: "app-news-post",
  templateUrl: "./news-post.component.html",
  styleUrls: ["./news-post.component.scss"]
})
export class NewsPostComponent implements OnInit {
  @Input() news: News;
  now = new Date();
  opened = false;

  constructor(private downloadService: DownloadService) {}

  ngOnInit(): void {}

  download(name: string, ext: string = null, path: string = null) {
    this.downloadService.download(path, name, ext);
  }

  open() {
    this.opened = !this.opened;
  }
}
